import * as Combobox from '@givebutter/primitives/combobox';
import { Separator } from '@givebutter/primitives/separator';
import { Timezone, useTimezones } from 'customHooks/useTimezones';

interface TimezoneSelectProps {
    value?: string;
    onChange?: (timezone: string) => void;
}

const TOP_TIMEZONES = [
    'America/New_York',
    'America/Chicago',
    'America/Denver',
    'America/Los_Angeles',
    'America/Anchorage',
    'Pacific/Honolulu',
];

const TimezoneSelect = ({ value, onChange, ...props }: TimezoneSelectProps) => {
    const timezones = useTimezones();
    const topTimezones = timezones?.filter(tz =>
        TOP_TIMEZONES.find(topTzName => topTzName === tz.name),
    );
    return (
        <Combobox.Root
            resource="timezone"
            allowMultiple={false}
            value={value ? [value] : []}
            onChangeValue={value => onChange?.(value[0] ?? '')}
        >
            <Combobox.Trigger aria-label="Select a timezone">
                <Combobox.Select placeholder="Select a timezone" />
            </Combobox.Trigger>
            <Combobox.Popover>
                <Combobox.Search />
                <Combobox.Items>
                    {topTimezones?.map(item => <RenderComboboxItem key={item.name} item={item} />)}
                    <Separator className="my-2 bg-gray-200" />
                    {timezones?.map(item => <RenderComboboxItem key={item.name} item={item} />)}
                </Combobox.Items>
            </Combobox.Popover>
        </Combobox.Root>
    );
};

const RenderComboboxItem = ({ item }: { item: Timezone }) => {
    return (
        <Combobox.Item value={item.name}>
            <Combobox.ItemText className="flex w-full">
                <div className="flex w-full flex-col">
                    <div className="flex flex-wrap items-center gap-x-1 font-normal">
                        <span className="break-all">{item.name}</span>
                        <small className="block text-xs font-medium text-neutral-500">
                            ({item.offset})
                        </small>
                    </div>
                    <small className="block text-xs text-gray-500">GMT {item.offsetShort}</small>
                </div>
            </Combobox.ItemText>
            <Combobox.CheckmarkIndicator />
        </Combobox.Item>
    );
};

export { TimezoneSelect };
export type { TimezoneSelectProps };
